<script>
  import { cssPrefix } from '../helper-classes.js'
</script>

<form class={`${cssPrefix}form`}>
  <slot name="header" />
  <slot />
  <slot name="footer" />
</form>
